import { IcosPaginationButton } from './button'
import { IcosPaginationPager } from './pager'
import { IcosPaginationSize } from './size'
import { IcosPaginationJump } from './jump'

export {
  IcosPaginationButton,
  IcosPaginationPager,
  IcosPaginationSize,
  IcosPaginationJump,
}

